<section class="hero" id="top">
  <div class="hero__bg" aria-hidden="true">
    <div class="hero__aurora"></div>
    <div class="hero__grid"></div>
    <div class="hero__trail t1"></div>
    <div class="hero__trail t2"></div>
    <div class="hero__trail t3"></div>
  </div>

  <div class="hero__inner cn-container cn-container--wide">
    <div>
      <div cnReveal>
        <span class="cn-badge cn-badge--glass">
          <span class="cn-badge__dot"></span>
          Fibra óptica · cobertura en expansión
        </span>
      </div>

      <h1 cnReveal cnRevealDelay="1" class="hero__title">
        Internet de Alta Velocidad que
        <span class="hl">Impulsa tu Mundo</span>
      </h1>

      <p cnReveal cnRevealDelay="2" class="hero__sub">
        Fibra simétrica de baja latencia para hogares y empresas. Streaming, gaming,
        teletrabajo y operación crítica — sin cortes, con soporte real <span [cnCountUp]="24" cnCountUpSuffix="/7"></span>.
      </p>

      <div cnReveal cnRevealDelay="3" class="hero__cta">
        <a class="cn-btn cn-btn--accent cn-btn--lg" href="#planes" data-magnetic>
          Ver Planes
          <lucide-icon name="arrow-right" [size]="20" />
        </a>
        <a class="cn-btn cn-btn--invert cn-btn--lg" href="#cobertura">
          <lucide-icon name="map-pin" [size]="20" />
          Consultar Cobertura
        </a>
      </div>

      <div cnReveal cnRevealDelay="4" class="hero__stats">
        <div class="cn-stat cn-stat--invert">
          <div class="cn-stat__value">
            <span [cnCountUp]="1" cnCountUpSuffix=" Gbps"></span>
          </div>
          <div class="cn-stat__label">Velocidad simétrica</div>
        </div>
        <div class="cn-stat cn-stat--invert">
          <div class="cn-stat__value">
            &lt;<span [cnCountUp]="5" cnCountUpSuffix=" ms"></span>
          </div>
          <div class="cn-stat__label">Latencia media</div>
        </div>
        <div class="cn-stat cn-stat--invert">
          <div class="cn-stat__value">
            <span [cnCountUp]="99.9" [cnCountUpDecimals]="1" cnCountUpSuffix=" %"></span>
          </div>
          <div class="cn-stat__label">Disponibilidad</div>
        </div>
      </div>
    </div>

    <div cnReveal cnRevealDelay="2" class="hero__visual" data-parallax>
      <div class="hero__orbit o1"></div>
      <div class="hero__orbit o2"></div>
      <div class="hero__orbit o3"></div>
      <div class="hero__glow"></div>
      <img class="hero__core" src="isotipo-cn-white.png" alt="ChircalNet CN" />
      <div class="hero__chip c1">
        <span class="dot"></span> Red operativa
      </div>
      <div class="hero__chip c2">
        <lucide-icon name="zap" [size]="16" style="color:var(--orange-400)" />
        <span [cnCountUp]="940" cnCountUpSuffix=" Mbps ↑↓"></span>
      </div>
      <div class="hero__chip c3">
        <lucide-icon name="shield-check" [size]="16" />
        <span [cnCountUp]="99.9" [cnCountUpDecimals]="1" cnCountUpSuffix="% uptime"></span>
      </div>
    </div>
  </div>
</section>
